//#region src/google/authError.ts
var AUTH_ERROR_QUERY_PARAM = "auth_error";
var AUTH_ERROR_CODES = [
	"missing_email",
	"provider_error",
	"record_not_found",
	"missing_strategy",
	"reauth_requires_login",
	"identity_mismatch",
	"unknown"
];
var MESSAGES = {
	missing_email: "We couldn't get an email from your Google account. Try again or sign in with email.",
	provider_error: "This email is already linked to a different sign-in method. Please use your original sign-in method.",
	record_not_found: "We couldn't find or create your account. Please try again or contact support.",
	missing_strategy: "Sign-in isn't available right now. Please try again in a moment.",
	reauth_requires_login: "Your session has expired. Please sign in again to continue.",
	identity_mismatch: "That Google account doesn't match the one you're signed in as. Please choose the matching account.",
	unknown: "Something went wrong signing you in. Please try again."
};
var normalizeAuthErrorCode = (raw) => {
	if (raw && AUTH_ERROR_CODES.includes(raw)) return raw;
	return "unknown";
};
var getAuthErrorMessage = (raw) => MESSAGES[normalizeAuthErrorCode(raw)];
var readRawAuthErrorFromLocation = () => {
	if (typeof window === "undefined") return null;
	const raw = new URLSearchParams(window.location.search).get(AUTH_ERROR_QUERY_PARAM);
	return raw && raw.length > 0 ? raw : null;
};
/**
* Removes `auth_error` from the current URL while preserving every other query
* param, the pathname, and the hash. Uses replaceState so the entry stays in
* history (no router event, no back/forward weirdness). No-op if the param is
* already absent or when running outside a browser.
*/
var stripAuthErrorFromUrl = () => {
	if (typeof window === "undefined") return;
	const url = new URL(window.location.href);
	if (!url.searchParams.has("auth_error")) return;
	url.searchParams.delete(AUTH_ERROR_QUERY_PARAM);
	const search = url.searchParams.toString();
	const newUrl = url.pathname + (search ? `?${search}` : "") + (url.hash || "");
	window.history.replaceState({}, "", newUrl);
};
//#endregion
export { getAuthErrorMessage, normalizeAuthErrorCode, readRawAuthErrorFromLocation, stripAuthErrorFromUrl };

